import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { DATA_TYPE, DATA_TYPE_LIST, TIME_TYPE_OBJ, } from "@/common/common-list-enum";
import piDatePicke from "@/components/pi-date-picke/pi-date-picke.vue";
import statisticsEcharts from "@/components/pi-statistics-echarts/pi-statistics-echarts.vue";
import i18n from "@/config/i18n";
import { piThThisTimes } from "@/utils/time.helper";
import { getMchStatisticsAmount, getHomeStatChargeCurve, } from "@/api/api-operation-service";
import { piOhGetProgress } from "@/utils/object.helper";
let PiOperDataRevenueData = class PiOperDataRevenueData extends Vue {
    constructor() {
        super(...arguments);
        this.time = [];
        this.dateTypeList = DATA_TYPE_LIST;
        this.timeTypeObj = TIME_TYPE_OBJ;
        this.formInline = {
            dateType: DATA_TYPE.month,
            beginTime: "",
            endTime: "",
        };
        this.win = window;
        this.lineConfig = {
            type: "line",
        };
        this.lineOption = {
            yAxis: {
                show: false,
            },
            legend: {
                show: false,
            },
            xAxis: {
                show: false,
            },
            series: [
                {
                    name: "",
                    type: "line",
                    data: [],
                    areaStyle: {
                        color: new this.win.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {
                                offset: 0,
                                color: "#FFE8CC",
                            },
                            {
                                offset: 1,
                                color: "rgba(255,236,209,3)",
                            },
                        ]),
                    },
                    symbolSize: 0,
                },
            ],
            tooltip: {
                show: false,
            },
            grid: {
                top: 1,
                left: 1,
                right: 1,
                bottom: -15,
            },
            color: ["#FFC01F"],
        };
        this.revenueList = [
            {
                name: i18n.t("operationData.totalTransAmount"),
                value: 0,
                key: "totalTransAmount",
                className: "bg-orange",
            },
            {
                name: i18n.t("operationData.totalTransServiceAmount"),
                value: 0,
                key: "totalTransServiceAmount",
                className: "bg-green",
                echart: {
                    title: { subtext: i18n.t("operationData.proportion") },
                    list: [{ value: "100%" }],
                    value: "100%",
                    color: ["#10CDAC", "#E7FCF9"],
                },
            },
            {
                name: i18n.t("operationData.totalTransElecAmount"),
                value: 0,
                key: "totalTransElecAmount",
                className: "bg-blue",
                echart: {
                    title: { subtext: i18n.t("operationData.proportion") },
                    list: [{ value: "100%" }],
                    value: "100%",
                    color: ["#336CFF", "#EBF0FF"],
                },
            },
            {
                name: i18n.t("operationData.totalTransDelayAmount"),
                value: 0,
                key: "totalTransDelayAmount",
                className: "bg-pink",
                echart: {
                    title: { subtext: i18n.t("operationData.proportion") },
                    list: [{ value: "100%" }],
                    value: "100%",
                    color: ["#F77234", "#FEF1EB"],
                },
            },
        ];
        this.revenueData = {};
        this.optionData = {
            isSubtext: true,
        };
    }
    /**
     * 时间选择
     */
    timeChange(val) {
        this.formInline.beginTime = val[0];
        this.formInline.endTime = val[1];
        this.getData();
    }
    /**
     * 获取数据
     */
    async getData() {
        const ret = await getMchStatisticsAmount(this.formInline);
        if (ret.status == this["$config"].apiStatus) {
            let data = ret.data[0] || {};
            this.revenueData = data;
            this.saveData(data);
        }
    }
    saveData(data) {
        let total = data.totalTransAmount || 0;
        let revenueList = JSON.parse(JSON.stringify(this.revenueList));
        revenueList.map((item) => {
            item.value = data[item.key] || 0;
            if (item.echart) {
                let value = piOhGetProgress(item.value, total, 1);
                item.echart.value = value;
            }
        });
        this.revenueList = revenueList;
    }
    /**
     * 获取统计图表数据
     */
    async getEchartLineData() {
        const ret = await getHomeStatChargeCurve({
            period: this.formInline.dateType,
        });
        if (ret.status == this["$config"].apiStatus) {
            let data = ret.data[0] || {};
            let lineOption = { ...this.lineOption };
            lineOption.series[0].data = data.totalAmountList;
            this.lineOption = lineOption;
        }
    }
    mounted() {
        let startTime = piThThisTimes("yyyy") + "-01";
        let endTime = piThThisTimes("yyyy-MM");
        this.formInline.beginTime = startTime;
        this.formInline.endTime = endTime;
        this.time = [startTime, endTime];
        this.getData();
        this.getEchartLineData();
    }
};
PiOperDataRevenueData = __decorate([
    Component({
        components: {
            "pi-date-picke": piDatePicke,
            "pi-statistics-echarts": statisticsEcharts,
        },
    })
], PiOperDataRevenueData);
export default PiOperDataRevenueData;
